import React from 'react';
import { graphql } from 'gatsby';
import {
  StyledButtonBlock,
} from './styles';
import { uid } from 'react-uid';

const GlobalContentBlocksButtonBlock = ({ block }) => {  
  return (    
      <StyledButtonBlock>        
        <h2 dangerouslySetInnerHTML={{ __html: block.title }} style={{textAlign:'center', width:'100%'}} />
        {block.ctaButtons.map((ctaButton) => { 
            const classes = (ctaButton.themeColor === "blue") ? "btn btn--primary btn--large" : "btn btn--secondary btn--large";
            return (
                <a
                  type="button"
                  href={ctaButton.url}
                  className={classes}
                  data-gtm-track="true"
                  data-gtm-event-type="cta"
                  key={uid(ctaButton)}
                >
                  {ctaButton.text}
                </a>           
            )
          })}
      </StyledButtonBlock>
  );
};

export default GlobalContentBlocksButtonBlock;

export const query = graphql`
  fragment ButtonBlockFragment on WPGraphQL_Page {
    acfGlobalContentBlocks {
      contentBlocks {
        ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_ButtonBlock {
          fieldGroupName
          title
          ctaButtons {
            ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_ButtonBlock_CtaButtons_Button {
              fieldGroupName
              text
              themeColor
              url
            }
          }
        }
      }
    }
  }
`;
